<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>海域監測</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>除針對溫排水的溫度進行連續監測外，亦定期對周邊海域進行地形測繪、水文調查 (海流、波浪、潮汐、風速風向、表面漂流)、動植浮游生物與仔稚魚，以及附近定置漁場、漁業經濟調查並追蹤。</p>
        <br>
        <div class="gallery gallery1">
          <div class="imgContainer1-1"></div>
          <div class="imgContainer1-2"></div>
        </div>
        <div class="gallery gallery2">
          <div class="imgContainer1-3"></div>
          <div class="imgContainer1-4"></div>
        </div>
        <div class="gallery gallery3">
          <div class="imgContainer1-5"></div>
          <div class="imgContainer1-6"></div>
        </div>
        <br>
        <p>鄰近和平電廠同屬台泥企業團的和平生態工業港，自 2019 年起獲得歐盟海事組織認證為生態港，2024 年更榮獲環境部國家環境教育獎民營企業組唯一特優的最高榮譽。2021 年和平生態工業港啟動「生態方塊珊瑚移植培育計畫」，以台泥低碳水泥打造生態方塊沉入海中成為人工魚礁，將因自然因素或港區浪潮沖斷的珊瑚斷枝，重新移植到生態方塊上，至 2024 年 7 月共復育 1,001 株，復育存活率達 80%，並展開魚貝類的生態調查。</p>
        <!-- <a href="#">→ 了解電廠與港口的海下生態</a> -->
        <!-- <br><br> -->
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">生態方塊珊瑚培育成果豐碩</div>
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="left">
          <div class="tit">工業港轉型生態港的歷程</div>
          <div class="history">
            <div class="item">
              <div class="year">2019</div>
              <div class="desp"><span class="tri"></span>榮獲 <b>歐盟海事組織認證</b> 為生態港</div>
            </div>
            <div class="item">
              <div class="year">2021</div>
              <div class="desp"><span class="tri"></span>生態港 <b>啟動生態方塊珊瑚移植培育計畫</b></div>
            </div>
            <div class="item">
              <div class="year">2024</div>
              <div class="desp"><span class="tri"></span>榮獲 <b>環境部國家環境教育獎</b> 最高榮譽</div>
            </div>
          </div>
          <div class="tit">生態方塊珊瑚移植培育計畫</div>
          <div class="coral" ref="coral">
            <div class="graphic">
              <img src="../../assets/environmentOcean/pic3_01.png">
            </div>
            <div class="data">
              <div class="amt">共 <span class="num1">1001</span> 株</div>
              <div class="ratio">存活率達 <span class="num2">80</span> %</div>
              <div class="deadline">統計至 2024 年 7 月止</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="right">
          <div class="tit">蓋一個珊瑚的家</div>
          <p>珊瑚佔海洋面積 0.2%、卻負擔 1/4 魚類的生存，台泥企業團長期關注生物多樣性議題，2021 年於旗下的和平港展開「生態方塊珊瑚移植培育計畫」，在水質媲美澎湖海域的和平生態工業港，為珊瑚蓋一個家。</p>
          <iframe width="100%" height="auto" src="https://www.youtube.com/embed/Aq_AZArAUQI?si=Qw7KdWtVo2TVL0i5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="clear"></div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Util, ImgContainerAutoResize, NumRun } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'EnvironmentOcean',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      coralOffsetTop: 0,
      coralBoundingBottom: 0,      
      coralHeight: 0,
      isShowNum: false
    }
  },
  methods:{
    showNum: function() {
      new NumRun(document.querySelector(".num1") as HTMLElement, 500);
      new NumRun(document.querySelector(".num2") as HTMLElement, 500);
    },
    chkShowNum: function() {
      let _this = this;
      this.coralBoundingBottom = (this.$refs.coral as HTMLElement).getBoundingClientRect().bottom;
      this.coralHeight = (this.$refs.coral as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (_this.coralBoundingBottom + 50)) {
        if(!_this.isShowNum) {          
          _this.isShowNum = true;
          _this.showNum();
        }
      }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop ) {
      // }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop + _this.coralHeight) {
      // }
    }
  },
  mounted() {
    setTimeout( () => {
      this.chkShowNum();
    }, 100);

    window.addEventListener("scroll", () => {
      this.chkShowNum();
    });

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.584);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 1.1);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-3") as HTMLElement, 1.25);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-4") as HTMLElement, 0.538);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-5") as HTMLElement, 0.45);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-6") as HTMLElement, 0.85);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".sect3 iframe") as HTMLElement, 0.5625);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/environmentOcean/kv.webp");
  background-position: center 15%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 p {
  margin: 0;
  line-height: 2em;
}

.sect1 .gallery {
  margin: 30px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 30px;
  overflow: hidden;
}

.sect1 .gallery .imgContainer1-1 {
  flex: 0 0 65%;
  background: url(../../assets/environmentOcean/pic1_01.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-2 {
  flex: 0 0 34.5%;
  background: url(../../assets/environmentOcean/pic1_02.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-3 {
  flex: 0 0 30%;
  background: url(../../assets/environmentOcean/pic1_03.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-4 {
  flex: 0 0 69.5%;
  background: url(../../assets/environmentOcean/pic1_04.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-5 {
  flex: 0 0 65%;
  background: url(../../assets/environmentOcean/pic1_05.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .gallery .imgContainer1-6 {
  flex: 0 0 34.5%;
  background: url(../../assets/environmentOcean/pic1_06.jpg) center no-repeat;
  background-size: cover;
}

.sect1 a {
  margin: 10px 0 20px;
  padding: 5px 20px;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 30px;
  border: solid 1px #000;
  color: #202020;
  background: #fff;
}

.sect2 {
  background: #63BFAA;
}

.sect2 .sectTit {
  width: 600px;
  margin: auto;
  padding: 20px;
  box-sizing: border-box;
  display: inline-block;  
  position: absolute;
  left: 0;
  right: 0;
  top: -45px;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-weight: bold;
  font-size: 36px;
  color: #63BFAA;
  background: #f4f3f3;
}

.sect2 .swiper {
  margin: 20px 0 0;
  border-radius: 20px;
}

.sect2 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect2 .swiper .cover1 {
    background: url(../../assets/environmentOcean/carousel2_01.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover2 {
    background: url(../../assets/environmentOcean/carousel2_02.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover3 {
    background: url(../../assets/environmentOcean/carousel2_03.webp) center 85%;
    background-size: cover;
}

.sect2 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

/* .swiper-button-next:after {
  padding: 10px;
  font-size: 60px;
  background: #00000088;
} */

.sect3 {
  background: #63BFAA;
}

.sect3 .tit {
  width: 490px;
  margin: 0 0 40px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 50px;
  border: solid 2px #fff;
  text-align: center;
  font-size: 36px;
  color: #fff;
}

.sect3 .left {
  width: 45%;
  padding: 0 40px 0 0;
  box-sizing: border-box;
  float: left;
  border-right: solid 5px #f4f3f3;
}

.sect3 .left .history {
  margin: 0 0 40px;
}

.sect3 .left .history .item {
  margin: 10px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  font-weight: bold;
}

.sect3 .left .history .item .year {
  flex: 0 0 100px;
  font-size: 28px;
  color: #F4CBB9;
}

.sect3 .left .history .item .desp {
  flex: 1 0 auto;
  padding: 15px 5px;
  position: relative;
  overflow: visible;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  text-align: left;
  font-weight: 500;
  font-size: 20px;
  background: #F4CBB9;
}

.sect3 .left .history .item .desp b {
  font-weight: 900;
}

.sect3 .left .history .item .desp .tri {
  width: 0;
  height: 0;
  position: absolute;
  left: -19px;
  top: 0;
  border-style: solid;
  border-width: 30px 20px 29px 0;
  border-color: transparent #F4CBB9 transparent transparent;
}

.sect3 .left .history .item:nth-child(2) .year {
  color: #F6D54D;
}

.sect3 .left .history .item:nth-child(2) .desp {
  background: #F6D54D;
}

.sect3 .left .history .item:nth-child(2) .desp .tri {
  border-color: transparent #F6D54D transparent transparent;
}

.sect3 .left .history .item:nth-child(3) .year {
  color: #fff;
}

.sect3 .left .history .item:nth-child(3) .desp {
  background: #fff;
}

.sect3 .left .history .item:nth-child(3) .desp .tri {
  border-color: transparent #fff transparent transparent;
}

.sect3 .left .coral .graphic {
  width: 45%;
  display: inline-block;
}

.sect3 .left .coral .graphic img {
  width: 100%;
  vertical-align: bottom;
}

.sect3 .left .coral .data {
  width: 45%;
  display: inline-block;
  text-align: right;
  font-size: 22px;
  color: #fff;
}

.sect3 .left .coral .data .amt .num1 {
  margin: 10px 0;
  display: inline-block;
  /* vertical-align: middle; */
  line-height: 1em;
  font-family: arial;
  font-size: 56px;
  color: #fff;
  opacity: 0;
  transform: translateY(2px);
}

.sect3 .left .coral .data .ratio .num2 {
  display: inline-block;
  vertical-align: top;
  line-height: 1em;
  font-family: arial;
  font-size: 60px;
  color: #F6D54D;
  opacity: 0;
  transform: translateY(-3px);
}

.sect3 .left .coral .data .deadline {
  width: 100%;
  margin: 15px 0 0;
  letter-spacing: -1px;
  font-size: 16px;
  color: #303030;
}

.sect3 .right {
  width: 55%;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  float: right;
}

.sect3 .right .tit {
  margin: 0 auto 30px;
}

.sect3 .right p {
  letter-spacing: 1px;
  line-height: 1.8em;
  font-size: 20px;
  color: #fff;
}

.sect3 .right iframe {
  margin: 20px 0 0;
  border-radius: 15px;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect3 .tit {
    margin: 20px auto;
  }

  .sect3 .left {
    width: 100%;
    padding: 0;
    border-right: none;
  }

  .sect3 .left .history {
    width: 70%;
    margin: 0 15% 60px;
  }

  .sect3 .left .coral {
    width: 70%;
    margin: 0 15% 40px;
  }

  .sect3 .left .coral .graphic {
  }

  .sect3 .left .coral .data {
    width: 55%;
  }

  .sect3 .right {
    width: 100%;
    margin: 40px 0 0;
    padding: 0;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .gallery {
    margin: 0;
  }

  .sect1 .gallery .imgContainer1-1 {
    flex: 0 0 100%;
  }

  .sect1 .gallery .imgContainer1-2 {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect1 .gallery .imgContainer1-3 {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect1 .gallery .imgContainer1-4 {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect1 .gallery .imgContainer1-5 {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect1 .gallery .imgContainer1-6 {
    flex: 0 0 100%;
  }

  .sect2 .sectTit {
    width: 320px;
    padding: 15px 5px;
    top: -35px;
    letter-spacing: 1px;
    font-size: 22px;
  }

  .sect3 .tit {
    width: 320px;
    margin: 0 auto 20px;
    padding: 10px;
    font-size: 24px;
  }

  .sect3 .left {
    width: 100%;
    padding: 0;
    border-right: none;
  }

  .sect3 .left .history .item .year {
    flex: 0 0 100%;
  }

  .sect3 .left .history .item .desp {
    flex: 1 0 auto;
    margin: 0 0 0 20px;
    font-size: 16px;
  }

  .sect3 .left .history .item .desp .tri {
    border-width: 27px 20px 27px 0;
  }

  .sect3 .left .coral .graphic {
    width: 40%;
  }

  .sect3 .left .coral .data {
    width: 60%;
  }
  
  .sect3 .left .coral .data .amt .num1 {
    font-size: 40px;
  }

  .sect3 .left .coral .data .ratio .num2 {
    font-size: 40px;
    transform: translateY(0px);
  }

  .sect3 .right {
    width: 100%;
    margin: 40px 0 0;
    padding: 0;
  }
}
</style>
